module.exports = __webpack_public_path__ + "static/img/05.4190de6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/05.png
// module id = 5odk
// module chunks = 2